import React from 'react';
import styled from 'styled-components';
import Tag from './Buttons/Tag';
import ShuffleButton from './Buttons/ShuffleButton';
import { categories } from '../videos-store';
import { displayFlex, width100 } from '../constants';

const StartComponent = styled.div`
  ${displayFlex}
  ${width100}
`;

const Tags = styled.div`
  ${displayFlex}
`;

export default function Start() {
  const tagList = categories.map(category => (
    <Tag key={category} category={category} />
  ));

  return (
    <StartComponent>
      <ShuffleButton />
      <Tags>
        {tagList}
      </Tags>
    </StartComponent>

  );
}
